import { Section } from '@dispatch/web/ui';
import { ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material';

export type IsForcedSectionProps = {
  isForced: boolean;
  setIsForced: React.Dispatch<React.SetStateAction<boolean>>;
};

export const IsForcedSection = ({
  isForced,
  setIsForced,
}: IsForcedSectionProps) => {
  return (
    <Section title="Force Assigned Task">
      <ToggleButtonGroup
        value={isForced}
        exclusive
        onChange={(_, isForced) => setIsForced(isForced)}
      >
        <ToggleButton value={true}>Yes</ToggleButton>
        <ToggleButton value={false}>No</ToggleButton>
      </ToggleButtonGroup>
    </Section>
  );
};
